import { getCookie } from "./cookie";

const memberKey = "ISDVCMEMBER";

const validateUserTypeContent = (
	item,
	userType,
	content,
	key,
	filterContent
) => {
	if (item && item.targetAudience && !item.targetAudience.includes(userType)) {
		delete content[key];
	} else {
		filterContent(item);
	}
};

export const filterContentByUserType = (originalContent, filterTypes, user) => {
	const contentToProcess = JSON.parse(JSON.stringify(originalContent));
	let userType = "";
	if (user?.swid) {
		userType = filterTypes[user.membership ? "memberLoggedIn" : "loggedIn"];
	} else {
		userType =
			getCookie(memberKey) === "1"
				? filterTypes["memberLoggedOut"]
				: filterTypes["loggedOut"];
	}
	const filterContent = (content) => {
		for (const key in content) {
			const item = content[key];
			if (typeof item === "object") {
				validateUserTypeContent(item, userType, content, key, filterContent);
				if (Array.isArray(item)) {
					if (Object.keys(item).length === 0) {
						content[key] = [];
					} else {
						content[key] = item.filter((element) => element);
					}
				}
			}
		}
	};
	filterContent(contentToProcess);
	return contentToProcess;
};
